import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import Home from './pages/home';
import Category from './pages/category';
import BusinessDetails from './pages/business-details';
import Recommend from './pages/recommend';
import Business from './pages/business';
import NotFound from './pages/notfound';
import About from './pages/about';
import Pricing from './pages/pricing';
import Faqs from './pages/faqs/index';
import Contact from './pages/contact/index';
import PrivacyPolicy from './pages/privacy';
import CookiesPolicy from './pages/cookies/index';
import Terms from './pages/terms/index';
import ScrollToTop from './components/scrollToTop';
import Blog from './pages/blog/index';
import SingleBlog from './pages/blog/single/index';


function App() {
  return (
    <Router>
      <div className="App bg-white">
        <ScrollToTop></ScrollToTop>
        <Routes>
          <Route path='/' element={< Home />}></Route>
          <Route path='/home' element={< Home />}></Route>
          <Route path='/businesses' element={< Category />}></Route>
          <Route path='/business-details' element={< BusinessDetails />}></Route>
          <Route path='/recommendation' element={< Recommend />}></Route>
          <Route path='/about' element={< About />}></Route>
          <Route path='/:businessName' element={<Business />} />
          <Route path='/404' element={<NotFound />} />
          <Route path='/pricing' element={<Pricing />} />
          <Route path='/faqs' element={<Faqs />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/cookies-policy' element={<CookiesPolicy />} />
          <Route path='/terms-and-conditions' element={<Terms />} />
          <Route path='/blogs' element={<Blog />} />
          <Route path='/blogs/:id' element={<SingleBlog />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
